import React from 'react';
import { Product, targetAppStore } from '../store';
import { ShoppingBag, Plus, Sparkles } from 'lucide-react';

interface ProductGridProps {
  products: Product[];
}

export const ProductGrid: React.FC<ProductGridProps> = ({ products }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h3 style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-1)', display: 'flex', alignItems: 'center', gap: 6 }}>
          <ShoppingBag size={14} style={{ color: 'var(--accent)' }} /> Available Gear & Promo Items
        </h3>
        <span style={{ fontSize: 11, color: 'var(--text-3)' }}>{products.length} catalog items</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
        {products.map((p) => (
          <div
            key={p.id}
            className="product-card"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 8,
              position: 'relative',
            }}
          >
            {p.isPromoFree && (
              <div
                style={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  background: 'var(--purple-soft)',
                  border: '1px solid var(--purple)',
                  color: 'var(--purple)',
                  fontSize: 9,
                  fontWeight: 700,
                  padding: '2px 6px',
                  borderRadius: 4,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                }}
              >
                <Sparkles size={10} /> FREE PROMO
              </div>
            )}

            <div>
              <div style={{ fontSize: 24, marginBottom: 4 }}>{p.imageEmoji}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-1)', lineHeight: 1.3 }}>
                {p.name}
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-3)' }}>{p.category}</div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
              <div className="price-tag" style={{ fontSize: 14 }}>
                {p.price === 0 ? '$0.00' : `$${p.price.toFixed(2)}`}
              </div>
              <button
                className="btn btn-sm"
                onClick={() => targetAppStore.addToCart(p)}
                style={{ padding: '4px 8px' }}
                title="Add to cart"
              >
                <Plus size={12} /> Add
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
